import { useState, useEffect } from "react";
import { BRAND, SCHOOLS, SENIOR_CATEGORIES } from "../constants";

function useIsMobile(breakpoint) {
  var [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < breakpoint
  );
  useEffect(function () {
    function onResize() { setIsMobile(window.innerWidth < breakpoint); }
    window.addEventListener("resize", onResize);
    return function () { window.removeEventListener("resize", onResize); };
  }, [breakpoint]);
  return isMobile;
}

export default function SearchBar({ search, onSearchChange, schoolFilter, onSchoolFilterChange, resultCount, hasFilters }) {
  var isMobile = useIsMobile(768);

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "12px 16px 6px" }}>
      <div style={{ display: "flex", gap: "8px" }}>
        <div style={{ position: "relative", flex: isMobile ? "1 1 60%" : "1 1 auto", minWidth: 0 }}>
          <input
            type="text"
            placeholder="Search by teacher or family name..."
            value={search}
            onChange={function(e) { onSearchChange(e.target.value); }}
            style={{
              width: "100%",
              padding: "10px 14px 10px 36px",
              border: "1.5px solid #DDD",
              borderRadius: "6px",
              fontSize: "14px",
              outline: "none",
              background: "#fff",
            }}
            onFocus={function(e) { e.target.style.borderColor = BRAND.primary; }}
            onBlur={function(e) { e.target.style.borderColor = "#DDD"; }}
          />
          <span style={{
            position: "absolute", left: "14px", top: "50%",
            transform: "translateY(-50%)", fontSize: "15px", opacity: 0.4,
          }}>{"\uD83D\uDD0D"}</span>
          {search && (
            <button
              onClick={function() { onSearchChange(""); }}
              style={{
                position: "absolute", right: "10px", top: "50%",
                transform: "translateY(-50%)", background: "#EEE",
                border: "none", borderRadius: "50%", width: "24px", height: "24px",
                cursor: "pointer", fontSize: "12px", color: "#888",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >{"\u2715"}</button>
          )}
        </div>
        <select
          value={schoolFilter}
          onChange={function(e) { onSchoolFilterChange(e.target.value); }}
          style={{
            padding: isMobile ? "10px 6px" : "10px 14px",
            flex: isMobile ? "0 1 35%" : "0 0 280px",
            minWidth: 0,
            border: "1.5px solid #DDD",
            borderRadius: "6px",
            fontSize: isMobile ? "13px" : "14px",
            background: "#fff",
            cursor: "pointer",
            outline: "none",
            color: "#444",
          }}
        >
          <option value="All">All Schools & Seniors</option>
          <optgroup label="Schools">
            {SCHOOLS.map(function(s) {
              return <option key={s} value={s}>{s}</option>;
            })}
          </optgroup>
          <optgroup label="Senior Tributes">
            {SENIOR_CATEGORIES.map(function(s) {
              return <option key={s} value={s}>{s}</option>;
            })}
          </optgroup>
        </select>
      </div>
      <div style={{ fontSize: "12px", color: "#AAA", marginTop: "6px", paddingLeft: "2px" }}>
        {hasFilters
          ? resultCount + " result" + (resultCount !== 1 ? "s" : "")
          : resultCount + " tributes"}
      </div>
    </div>
  );
}
